__turbopack_context__.v({
  "active": "TimerInlinePicker-module__K6XOpW__active",
  "dropdown": "TimerInlinePicker-module__K6XOpW__dropdown",
  "option": "TimerInlinePicker-module__K6XOpW__option",
  "selectWrapper": "TimerInlinePicker-module__K6XOpW__selectWrapper",
  "setButton": "TimerInlinePicker-module__K6XOpW__setButton",
  "trigger": "TimerInlinePicker-module__K6XOpW__trigger",
  "wrapper": "TimerInlinePicker-module__K6XOpW__wrapper",
});
